import React from 'react';
import { Download } from 'lucide-react';
interface DownloadHandoutProps {
  title: string;
  fileUrl: string;
  fileType: string;
}
const DownloadHandout: React.FC<DownloadHandoutProps> = ({
  title,
  fileUrl,
  fileType
}) => {
  return <div className="mt-6 mb-6 p-4 bg-blue-50 rounded-lg border border-blue-100" data-id="element-144">
      <div className="flex items-center justify-between" data-id="element-145">
        <div data-id="element-146">
          <h4 className="font-medium text-gray-800" data-id="element-147">{title}</h4>
          <p className="text-sm text-gray-600" data-id="element-148">Download for offline reading</p>
        </div>
        <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="flex items-center text-blue-600 hover:text-blue-800 transition-colors" data-id="element-149">
          <Download className="mr-1 h-4 w-4" data-id="element-150" />
          <span data-id="element-151">Download {fileType.toUpperCase()}</span>
        </a>
      </div>
    </div>;
};
export default DownloadHandout;